module.exports = __webpack_public_path__ + "static/media/freeDirt.5bca7260.jpg";